// extracted by mini-css-extract-plugin
export default {"menu":"menu___lmCy5","right":"right___j6QWS","search":"search___XbFIL","account":"account___t6Nrx","avatar":"avatar___B76fn","name":"name___kZtlh"};